import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withXsrfConfiguration } from '@angular/common/http';

import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import {provideTranslocoLocale} from '@jsverse/transloco-locale';


export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(withXsrfConfiguration({
      cookieName: 'csrftoken', headerName: 'X-CSRFToken'})),
     provideTransloco({
        config: {
          availableLangs: [{id: 'de', label: "Deutsch"}],
          defaultLang: window.navigator.language.split('-')[0],
          fallbackLang: 'de',
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
        },
        loader: TranslocoHttpLoader
      }),
    provideTranslocoLocale({
      langToLocaleMapping: {
        de: 'de-DE'
      }
    })]
};
